import app from 'flarum/forum/app';
import { extend as mithrilExtend } from 'flarum/common/extend';
import HeaderPrimary from 'flarum/forum/components/HeaderPrimary';
import SessionDropdown from 'flarum/forum/components/SessionDropdown';
import LinkButton from 'flarum/common/components/LinkButton';
import profile from './profile';
import experience from './experience';
import applications from './applications';
export { default as extend } from './extend';
const MAIN_SITE_URL = 'https://thehideoutcommunity.com';
function connectBrandToMainSite() {
  const brandLink = document.querySelector('.Header-title a');
  if (!(brandLink instanceof HTMLAnchorElement)) {
    return;
  }
  brandLink.href = MAIN_SITE_URL;
  brandLink.title = 'Return to The Hideout main site';
  brandLink.onclick = event => {
    event.preventDefault();
    window.location.assign(MAIN_SITE_URL);
  };
}
app.initializers.add('thehideout-flarum-core', () => {
  profile();
  experience();
  applications();
  mithrilExtend(HeaderPrimary.prototype, 'items', function (items) {
    items.add('hideout-punishments', m(LinkButton, {
      className: "Button Button--link HideoutPunishmentsLink",
      href: app.route('hideout.punishments'),
      icon: "fas fa-shield-halved"
    }, "Punishments"), 10);
  });
  /*
   * The header is rendered by Flarum after initializers
   * execute. Running this after HeaderPrimary renders
   * ensures the branding link always points home.
   */
  mithrilExtend(HeaderPrimary.prototype, 'view', function () {
    window.requestAnimationFrame(connectBrandToMainSite);
  });
  mithrilExtend(SessionDropdown.prototype, 'items', function (items) {
    if (!app.session.user) {
      return;
    }
    items.add('hideout-connected-accounts', m(LinkButton, {
      href: app.route('hideout.connectedAccounts'),
      icon: "fas fa-link"
    }, "Connected Accounts"), 85);
    if (typeof app.session.user.isAdmin === 'function' && app.session.user.isAdmin() && Number(app.session.user.id()) === 1) {
      items.add('hideout-staff-management', m(LinkButton, {
        href: app.route('hideout.staffManagement'),
        icon: "fas fa-user-shield"
      }, "Staff Management"), 84);
    }
  });
});